// extracted by mini-css-extract-plugin
export default {"headline":"EventsInfo_headline__Blo1V"};